/* 馬超傳・第 5 章：冀城（下）鹵城（建安十七年，212）
 * 史實：〈楊阜傳〉「十七年九月，與叙起兵於鹵城。超聞阜等兵起，自將出。而衢、寬等解岳，閉冀城門，討超妻子。……
 *       阜與超戰，身被五創，宗族昆弟死者七人。超遂南奔張魯。」
 *       〈馬超傳〉「阜、叙起於鹵城，超出攻之，不能下；寬、衢閉冀城門，超不得入。」
 *       《武帝紀》「南安趙衢、漢陽尹奉等討超，梟其妻子，超奔漢中。」
 * 這是第 5 章的第二幕（def.of，第一幕是圍城 machao5a）。
 * 流程：楊阜、姜敘在鹵城起兵，馬超出城攻打；城上放箭，城門攻不破。攻到一半，冀城的城門在背後關上。
 *       回到冀城門下，城門緊閉，妻兒被害（劇情）。楊阜帶兵追來，打退他（身被五創）之後往南奔漢中。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, troop } from '../kit.ts';
import { MEN, band } from './machao_kit.ts';
import { JI, LU, JI_GATE, LU_GATE, SOUTH } from '../maps/machao_jicheng.ts';

const LV = 14, ATTACK = 30;
const ZHOU = troop('liang-soldier', '州兵', { armor: '#4a5a6a', sleeve: '#3a4652', cloth: '#3a4652', plume: '#8a9aaa' });
const ZB = { spec: ZHOU, name: '州兵', hp: 500, maxHp: 500, atk: 24 };

export default {
  id: 'machao-5', of: 'machao-5a', map: 'machao_jicheng', hero: 'machao',
  title: '第 5 章　冀城', year: '建安十七年（212）',
  brief: {
    quote: [{ text: '阜、叙起於鹵城，超出攻之，不能下；寬、衢閉冀城門，超不得入。', src: '《三國志·蜀書·馬超傳》' }],
    text: '馬超據冀城之後，韋康的舊部楊阜和表兄姜敘暗中結約，聯絡梁寬、趙衢，在鹵城起兵。馬超親自出城攻打鹵城。',
    goals: ['攻打鹵城', '冀城門閉：回到冀城', '擊退追來的楊阜', '往南奔漢中'],
  },
  words: { ally: '西涼騎', foe: '州兵' },
  stars: [ // 兩幕合算
    { text: '圍城：截下 5 支以上糧隊', ok: (m) => !m.prev || (m.prev.vars.cut || 0) >= 5 },
    { text: '圍城：140 秒內韋康開城', ok: (m) => !m.prev || (m.prev.vars.fallT != null && m.prev.vars.fallT < 140) },
    { text: '龐德沒有倒下', ok: (m) => !m.vars.pdDown },
  ],
  steps: [
    { // 0. 攻鹵城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = LU_GATE[0] - 1100; me.y = LU_GATE[1];
        V.t0 = w.t; V.arrowT = 2;
        V.pd = ally(w, 'pangde', me.x - 80, me.y + 90, LV);
        V.men = band(m, me, 10, '西涼騎', { hp: 640, atk: 26 });
        m.gate('lu', LU_GATE[0], LU_GATE[1], 190, 'citygate');
        V.jx = boss(w, MEN.jiangxu, LU_GATE[0] - 220, LU_GATE[1] + 80, { name: '姜敘', hp: 5000, atk: 30, armor: 8, ms: 220 });
        V.def = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', LU_GATE[0] - 200 - (i % 5) * 70, LU_GATE[1] - 260 + Math.floor(i / 5) * 520, ZB); u.home = [u.x, u.y]; return u; });
        m.card('十七年九月，與叙起兵於鹵城。超聞阜等兵起，自將出。', '《三國志·魏書·楊阜傳》');
        m.line('馬超', '楊阜、姜敘，竟敢反我！');
        m.mark('lu', LU_GATE[0], LU_GATE[1], '鹵城');
        m.obj('lu', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        m.get('lu').text = `攻打鹵城（${Math.min(ATTACK, Math.floor(t))}/${ATTACK} 秒）`;
        if (V.jx.hp < V.jx.maxHp * 0.5) V.jx.hp = V.jx.maxHp * 0.5; // 不能下
        // 城上放箭
        if ((V.arrowT -= dt) <= 0 && SG.gd(me.x, me.y, LU_GATE[0], LU_GATE[1]) < 650) { V.arrowT = 2.6; m.strike(me.x + (SG.rand() - 0.5) * 120, me.y + (SG.rand() - 0.5) * 80, 120, 1.1, 40, 0); } // 城上放箭：站著挨射會掉血
        return t >= ATTACK;
      },
    },
    { // 1. 冀城門閉
      enter(m, w) {
        const V = m.vars;
        m.done('lu'); m.unmark('lu');
        m.big('冀城的城門關上了！');
        m.card('衢、寬等解岳，閉冀城門，討超妻子。', '〈楊阜傳〉');
        m.gate('ji', JI_GATE[0], JI_GATE[1], 190, 'citygate');
        V.jx.home = [LU_GATE[0] - 220, LU_GATE[1]];
        m.line('龐德', '將軍，冀城出事了！');
        m.mark('ji', JI_GATE[0], JI_GATE[1] + 150, '冀城南門');
        m.obj('ji', '回冀城');
      },
      tick(m, w) { return m.near(w.player, JI_GATE[0], JI_GATE[1] + 150, 380); },
    },
    { // 2. 超不得入；楊阜追來
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('ji'); m.unmark('ji');
        m.line('趙衢', '（城上）馬超！你背父叛君，虐殺州將，還想進城？');
        m.after(2.5, () => m.card('南安趙衢、漢陽尹奉等討超，梟其妻子。', '《三國志·魏書·武帝紀》'));
        m.after(4, () => m.line('馬超', '…………！'));
        m.after(6, () => {
          V.yf = boss(w, MEN.yangfu, me.x + 900, me.y + 500, { name: '楊阜', hp: 4000, atk: 32, armor: 8, ms: 240 });
          V.yf.home = [me.x, me.y];
          for (let i = 0; i < 6; i++) { const u = m.foe('huangjin', me.x + 1000 + (i % 4) * 70, me.y + 400 + Math.floor(i / 4) * 140, ZB); u.home = [me.x, me.y]; }
          m.big('楊阜追來了！');
          m.mark('yf', V.yf.x, V.yf.y, '楊阜', false, V.yf);
          m.obj('yf', '擊退楊阜');
        });
      },
      tick(m, w) {
        const V = m.vars, me = w.player;
        if (!V.yf) return false;
        if (V.yf.alive && !(V.yf.target && V.yf.target.alive)) V.yf.home = [me.x, me.y];
        return V.yf.hp < V.yf.maxHp * 0.65;
      },
    },
    { // 3. 身被五創；南奔
      enter(m, w) {
        const V = m.vars;
        m.done('yf'); m.unmark('yf');
        V.yf.untargetable = true; V.yf.home = [JI.x + 400, JI.y + 900]; V.yf.target = null; V.yf.ms = 200;
        m.card('阜與超戰，身被五創，宗族昆弟死者七人。', '〈楊阜傳〉');
        m.after(3, () => m.line('龐德', '冀城回不去了。往南，投漢中張魯！'));
        m.mark('south', SOUTH[0], SOUTH[1] - 150, '往漢中');
        m.obj('south', '往南奔漢中');
      },
      tick(m, w) { return m.near(w.player, SOUTH[0], SOUTH[1] - 150, 320); },
    },
    { // 4. 超遂南奔張魯
      enter(m, w) {
        m.done('south'); m.unmark('south');
        for (const u of w.units) if (u.team === 1 && u.alive) { u.untargetable = true; u.target = null; }
        m.card('超遂南奔張魯。', '〈楊阜傳〉');
        m.after(4, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('馬超陣亡'); return; }
    if (V.pd) { if (!V.pd.alive) V.pdDown = true; allyTick(w, V.pd, w.player, m.i === 1 || m.i === 3 ? 0 : 450); }
  },
};
